// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/demand_forecast_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { DemandForecastService } from "./demand_forecast_service_pb";

/**
 * GetDemandForecastDaily returns the aggregated editing page for the given
 * (case_id, area_code, section, target_date). The page contains all retailer
 * drafts under the case, the read-only BG-total slot series, past actuals,
 * confirm-record baselines, and weather data. For the TODAY section, a
 * retailer with no saved draft is seeded from its confirmed history
 * (前日確定値). For TOMORROW / DAY_AFTER_TOMORROW, a retailer with no saved
 * draft returns empty slots (未入力).
 *
 * @generated from rpc bffuser.v1.DemandForecastService.GetDemandForecastDaily
 */
export const getDemandForecastDaily = DemandForecastService.method.getDemandForecastDaily;

/**
 * GetDemandForecastWeekly returns the read-only page of a weekly case: the
 * BG-total series, power summary and weather of every day of the case's
 * forecast period. The period and area are derived from the case. Rejects
 * with FAILED_PRECONDITION while the weekly section is not released, and
 * with INVALID_ARGUMENT when the case does not exist, is not weekly, or has
 * no BG. Read-only: never seeds or writes drafts.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.GetDemandForecastWeekly
 */
export const getDemandForecastWeekly = DemandForecastService.method.getDemandForecastWeekly;

/**
 * SaveDemandForecastDraft persists the operator's 48-slot edits for a single
 * retailer (identified by retailer_business_cd) as a draft (明示「保存」操作). Uses
 * optimistic locking via expected_updated_at; omit on the first save.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.SaveDemandForecastDraft
 */
export const saveDemandForecastDraft = DemandForecastService.method.saveDemandForecastDraft;

/**
 * AllocateUnattributedDemandForecast moves the saved 帰属不明 to one retailer
 * on all 48 komas, GC 済み komas included (AC-DFD-057).
 * organization_id and acting_member_id are resolved from the eauth session.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.AllocateUnattributedDemandForecast
 */
export const allocateUnattributedDemandForecast = DemandForecastService.method.allocateUnattributedDemandForecast;

/**
 * ConfirmDemandForecast batch-freezes the saved drafts for all specified
 * retailers as business-confirmed demand records (業務確定). Uses per-retailer
 * optimistic locking via targets[].expected_updated_at (required per target).
 *
 * @generated from rpc bffuser.v1.DemandForecastService.ConfirmDemandForecast
 */
export const confirmDemandForecast = DemandForecastService.method.confirmDemandForecast;

/**
 * SearchSimilarDays searches for past days that are similar to the given
 * target_date within the specified lookback window, ranked by similarity
 * score (S(d), lower = more similar). Used by the similar-day selection
 * dialog (類似日検索ダイアログ). organization_id is intentionally absent;
 * the BFF handler resolves it from the eauth session.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.SearchSimilarDays
 */
export const searchSimilarDays = DemandForecastService.method.searchSimilarDays;

/**
 * RecordSimilarDayPicks records which similar-day candidates the operator
 * selected ("applied"). Fire-and-forget; failure does not block UI apply.
 * organization_id is intentionally absent; the BFF handler resolves it
 * from the eauth session.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.RecordSimilarDayPicks
 */
export const recordSimilarDayPicks = DemandForecastService.method.recordSimilarDayPicks;

/**
 * PreviewConfirmRecord previews a previously confirmed demand record
 * (DemandConfirmRecord) as a non-destructive reference column (確定履歴の
 * 参照列プレビュー, s07-confirm-history-import-reference-view.md) WITHOUT
 * touching the draft. The client applies the result as an additional
 * reference column/series alongside the editable draft (過去実績と同挙動);
 * persistence of the editable draft continues to happen only via
 * SaveDemandForecastDraft. The BFF determines scope (RETAIL or BG_TOTAL)
 * from the request and forwards to the internalapi. organization_id is
 * resolved from eauth.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.PreviewConfirmRecord
 */
export const previewConfirmRecord = DemandForecastService.method.previewConfirmRecord;

/**
 * GetSimpleForecastEntryDefaults returns default source-date / weight
 * suggestions for the simple-forecast entry table (簡易予測入力), given the
 * selected derivation method. When dates is empty, the backend derives its
 * own default set of source dates. organization_id is intentionally
 * absent; the BFF handler resolves it from the eauth session.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.GetSimpleForecastEntryDefaults
 */
export const getSimpleForecastEntryDefaults = DemandForecastService.method.getSimpleForecastEntryDefaults;

/**
 * ListSimpleForecastUnavailableSourceDates returns the 実績の無い日
 * (simple-methods AC-DFM-014 / 017) in [from_date, to_date] for the
 * settings dialog's date picker. organization_id is resolved from the eauth
 * session.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.ListSimpleForecastUnavailableSourceDates
 */
export const listSimpleForecastUnavailableSourceDates = DemandForecastService.method.listSimpleForecastUnavailableSourceDates;

/**
 * PreviewSimpleForecast derives forecast slots using the given simple-forecast
 * method (簡易予測取込のプレビュー) WITHOUT persisting anything. The client
 * applies the result to its unsaved edit buffer; persistence happens only via
 * SaveDemandForecastDraft (明示保存). GC-passed komas are merged from the
 * existing draft server-side (same merge as the former import RPC).
 * organization_id is intentionally absent; resolved from eauth.
 * scope MUST be RETAIL: BG_TOTAL is rejected by the backend with
 * InvalidArgument because 需要想定値の投入単位は小売事業者のみ (spec
 * demand-forecast-daily.md AC-DFD-033/033a, 2026-08-12 決定).
 *
 * @generated from rpc bffuser.v1.DemandForecastService.PreviewSimpleForecast
 */
export const previewSimpleForecast = DemandForecastService.method.previewSimpleForecast;

/**
 * PreviewTrendReflection recomputes the trend reflection preview (avgRatio +
 * GC以降補正) for the same-day section using a caller-supplied aggregation
 * window (集計窓, spec AC-DFD-009a). WITHOUT persisting anything. organization_id
 * is intentionally absent; resolved from eauth.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.PreviewTrendReflection
 */
export const previewTrendReflection = DemandForecastService.method.previewTrendReflection;

/**
 * GetDemandForecastRetailerBreakdown returns the 内訳 of one retailer on the
 * 需要想定 (単日) page: its 想定モード and, for グループ別, the past actuals of
 * each 需要グループ and その他. Independent of GetDemandForecastDaily: call it
 * only while a retailer is the target, and show a failure in the 内訳 area
 * only. Mirrors internalapi.v1.DemandForecastService.
 *
 * @generated from rpc bffuser.v1.DemandForecastService.GetDemandForecastRetailerBreakdown
 */
export const getDemandForecastRetailerBreakdown = DemandForecastService.method.getDemandForecastRetailerBreakdown;

/**
 * @generated from rpc bffuser.v1.DemandForecastService.PreviewAggregateEdit
 */
export const previewAggregateEdit = DemandForecastService.method.previewAggregateEdit;
